module.exports = __webpack_public_path__ + "img/ltkcyberweek-4x.5329670.jpg";